<template>
    <D3ForceGraph :data="data" />
</template>

<script>
import D3ForceGraph from './D3ForceGraph.vue'

export default {
    name: 'GraphVisualizer',
    components: { D3ForceGraph },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
